import { ApiCaller } from '../../api-caller.service';
import { AddressConnector } from './address';

export class PublicConnector {
  constructor(
    private apiCaller: ApiCaller,
    private prefix: string,
  ) {}

  address = () => new AddressConnector(this.apiCaller, this.prefix);
}
